module.exports = __webpack_public_path__ + "img/add.9b7961d5.svg";